import { render, staticRenderFns } from "./SearchDataList.vue?vue&type=template&id=18b0b1aa&scoped=true&"
import script from "./SearchDataList.vue?vue&type=script&lang=js&"
export * from "./SearchDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b0b1aa",
  null
  
)

export default component.exports